import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

Alpine.plugin(collapse)

// Header
Alpine.data('header', () => ({
    isOpen: false,
    isScrolled: false,
    init() {
        this.isOpen = false
        this.handleScroll()
        window.addEventListener('scroll', () => this.handleScroll(), { passive: true })
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) this.closeMenu()
        })
    },
    toggleMenu() {
        this.isOpen = !this.isOpen
        document.body.classList.toggle('overflow-hidden', this.isOpen)
    },
    closeMenu() {
        this.isOpen = false
        document.body.classList.remove('overflow-hidden')
    },
    handleScroll() {
        this.isScrolled = window.scrollY > 20
    },
    trackPhoneClick() {
        if (typeof trackEvent === 'function') trackEvent('phone_click', 'engagement', 'header');
    }
}))

// Contact modal
Alpine.data('contactModal', () => ({
    isOpen: false,
    isSubmitting: false,
    formData: { name: '', email: '', phone: '', enquiry_for: '', message: '' },
    init() {
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) this.closeModal()
        })
    },
    openModal() {
        this.isOpen = true
        document.body.classList.add('overflow-hidden')
    },
    closeModal() {
        this.isOpen = false
        document.body.classList.remove('overflow-hidden')
        this.formData = { name: '', email: '', phone: '', enquiry_for: '', message: '' }
    },
    async submitForm() {
        this.isSubmitting = true
        try {
            const formData = new FormData()
            formData.append('_token', document.querySelector('meta[name=csrf-token]').getAttribute('content'))
            Object.entries(this.formData).forEach(([k, v]) => formData.append(k, v))
            const response = await fetch('/contact', {
                method: 'POST',
                body: formData,
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
            const data = await response.json()
            if (data.success) {
                this.formData = { name: '', email: '', phone: '', enquiry_for: '', message: '' }
                setTimeout(() => this.closeModal(), 2000)
            }
        } catch (e) {
            console.error('Form error:', e)
        } finally {
            this.isSubmitting = false
        }
    }
}))

// Hero Slider
Alpine.data('heroSlider', () => ({
    current: 0,
    timer: null,
    slides: [
        {
            image: '/storage/hero-images/1.webp',
            headline: 'Expert Drivers, Safe Journeys',
            sub: '6,00,000+ km of real road experience — safe, confident travel across city roads, highways & ghat sections'
        },
        {
            image: '/storage/hero-images/2.webp',
            headline: 'Your Trusted Travel Partner in Mangalore',
            sub: 'Airport transfers, temple tours, outstation trips & customized tour packages across coastal Karnataka'
        },
        {
            image: '/storage/hero-images/3.webp',
            headline: 'Tempo Traveller & Bus Hire in Mangalore',
            sub: 'Wedding car rental, Innova Crysta on rent, 12-50 seater group travel — the right vehicle for every occasion'
        }
    ],
    init() {
        this.startTimer()
    },
    startTimer() {
        this.timer = setInterval(() => this.next(), 5000)
    },
    next() {
        this.current = (this.current + 1) % this.slides.length
    },
    goTo(index) {
        this.current = index
        clearInterval(this.timer)
        this.startTimer()
    }
}))

// Utility
window.utils = {
    formatPhone(phone) {
        return phone.replace(/(\+91)(\d{5})(\d{5})/, '$1 $2-$3')
    }
}

// Scroll reveal — IntersectionObserver, animate once
function initScrollAnimations() {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible')
                observer.unobserve(entry.target)
            }
        })
    }, { threshold: 0.15 })

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el))
}

// Native lazy loading for images without loading="lazy" attribute
function initLazyImages() {
    if ('loading' in HTMLImageElement.prototype) return // browser supports native lazy

    const imgObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target
                if (img.dataset.src) {
                    img.src = img.dataset.src
                    img.removeAttribute('data-src')
                }
                imgObserver.unobserve(img)
            }
        })
    }, { rootMargin: '200px' })

    document.querySelectorAll('img[data-src]').forEach(img => imgObserver.observe(img))
}

document.addEventListener('DOMContentLoaded', () => {
    initScrollAnimations()
    initLazyImages()
})

window.Alpine = Alpine
Alpine.start()
